<template>
  <div class="state-block state-loading" role="status">
    <span class="loading-line"></span>
    <span>{{ label || $store.getters.t('loading') }}</span>
  </div>
</template>

<script>
export default { name: 'LoadingState', props: { label: String } }
</script>
